import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=045f4406&"
import script from "./PieChartCard.vue?vue&type=script&lang=js&"
export * from "./PieChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports